import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from 'vue';
import {
  BaseFormItem,
  BaseTextContent,
  BaseTextTitle,
  BaseForm
} from 'xrk-components';
import { IndividualInfoDetailData } from '../../data-source/types';
import { LICENSE_AUDIT_STATUS, INDIVIDUAL_TYPE } from '../../constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'platform',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {

const formData = _useModel<IndividualInfoDetailData>(__props, "modelValue");
const ruleFormRef = ref(null);

const auditText = computed(() => {
  if (formData.value.auditStatus >= 21) return '平台通过';
  if (formData.value.auditStatus)
    return LICENSE_AUDIT_STATUS[formData.value.auditStatus].label;
  return '';
});

__expose({
  validate: () => {
    return ruleFormRef.value.validate();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(BaseTextTitle), { class: "account-info__items__title" }, {
      default: _withCtx(() => [
        _createTextVNode("平台审核")
      ]),
      _: 1
    }),
    _createVNode(_unref(BaseTextContent), null, {
      default: _withCtx(() => [
        _createVNode(_unref(BaseForm), {
          class: "account-info__items",
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          disabled: "",
          model: formData.value,
          "column-count": 1
        }, {
          default: _withCtx(() => [
            (formData.value.auditStatus == 14)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_unref(BaseFormItem), {
                    label: "操作",
                    prop: "auditStatus"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(LICENSE_AUDIT_STATUS)[formData.value.auditStatus]?.label), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "原因类别",
                    prop: "auditTerminationReason"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(formData.value.auditTerminationReason), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "备注",
                    prop: "auditTerminationRemark"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(formData.value.auditTerminationRemark), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_unref(BaseFormItem), {
                    label: "个体户类别",
                    prop: "individualType"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_unref(INDIVIDUAL_TYPE)[formData.value.individualType]?.label), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(BaseFormItem), {
                    label: "意见",
                    prop: "individualType"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(auditText.value), 1)
                    ]),
                    _: 1
                  })
                ], 64))
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    })
  ], 64))
}
}

})